function getOptimizedImageSize(el, max, crop) {
  const [maxWidth, maxHeight] = max.split('x').map(Number);
  const density = window.devicePixelRatio || 1;
  const width = el.offsetWidth || 300;
  const height = el.offsetHeight || 300;

  let finalWidth, finalHeight;

  if (crop) {
    finalWidth = Math.min(Math.round(width * density), maxWidth);
    finalHeight = Math.min(Math.round(height * density), maxHeight);
  } else {
    const containerRatio = width / height;
    const imageRatio = maxWidth / maxHeight;

    if (containerRatio > imageRatio) {
      finalWidth = Math.min(Math.round(width * density), maxWidth);
      finalHeight = Math.min(Math.round(finalWidth / imageRatio), maxHeight);
    } else {
      finalHeight = Math.min(Math.round(height * density), maxHeight);
      finalWidth = Math.min(Math.round(finalHeight * imageRatio), maxWidth);
    }
  }

  return `${finalWidth}x${finalHeight}`;
}

function forceLoadBackgroundImage() {
  const elements = document.querySelectorAll('[data-rimg="lazy"][data-type-x="bg"]');

  elements.forEach(el => {
    const template = el.getAttribute('data-rimg-template');
    const max = el.getAttribute('data-rimg-max');
    const crop = el.getAttribute('data-rimg-crop') === 'true';

    if (!template || !max) return;

    const size = getOptimizedImageSize(el, max, crop);
    const imageUrl = template.replace('{size}', size);
    el.style.backgroundImage = `url('${imageUrl}')`;

    el.setAttribute('data-rimg', 'loaded');
  });
}

function forceLoadImage() {
  const elements = document.querySelectorAll('[data-rimg="lazy"][data-type-x="img"]');

  elements.forEach(el => {
    const template = el.getAttribute('data-rimg-template');
    const max = el.getAttribute('data-rimg-max');
    const crop = el.getAttribute('data-rimg-crop') === 'true';

    if (!template || !max) return;

    const size = getOptimizedImageSize(el, max, crop);
    const imageUrl = template.replace('{size}', size);
    el.srcset = imageUrl;

    el.setAttribute('data-rimg', 'loaded');
  });
}

if (window.innerWidth >= 1024) {
  forceLoadImage();
  forceLoadBackgroundImage();
}
